import { render } from "./CookieModal.vue?vue&type=template&id=2d280bf6&scoped=true"
import script from "./CookieModal.vue?vue&type=script&lang=js"
export * from "./CookieModal.vue?vue&type=script&lang=js"

import "./CookieModal.vue?vue&type=style&index=0&id=2d280bf6&scoped=true&lang=scss"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d280bf6"]])

export default __exports__